/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Gift_Payer_Customer_WarningInputs */

const vi_carrier_form_gift_payer_customer_warning = /** @type {(inputs: Carrier_Form_Gift_Payer_Customer_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn quà đã thu ship trả trước, không thu cước người nhận — chọn "Người nhận trả cước" cũng không cộng cước vào tiền thu hộ.`)
};

/**

* @param {Carrier_Form_Gift_Payer_Customer_WarningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_gift_payer_customer_warning = /** @type {((inputs?: Carrier_Form_Gift_Payer_Customer_WarningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Gift_Payer_Customer_WarningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_gift_payer_customer_warning(inputs)
});